module.exports = __webpack_public_path__ + "img/laft_bg4.525b121d.png";